import logo from "../assets/img/logogrande.png";
import { FaHeadset } from "react-icons/fa6";

import Transparencia from "./../assets/js/transparenica";

const Footers = () => {
  return (
    <footer className="w-full">
      <div className="w-full p-1 px-4 bg-gray800 text-viking">
        <div className="container px-8 mx-auto py-7">
          <div className="grid grid-cols-1 gap-3 lg:grid-cols-4 md:grid-cols-2">
            <div className="flex items-center py-5 text-sm text-center">
              <img
                src={logo}
                alt="SinntecPon"
                className="w-[300px] h-[100px] block m-auto"
              />
              <p></p>
            </div>
            <div className="py-10 text-center">
              <p className="text-2xl font-bold">Horarios de atención</p>
              <div className="py-3 font-bold text-white">
                <p className="flex items-center justify-center gap-2">
                  <FaHeadset className="text-viking" />
                  <span>Centro de atención a clientes</span>
                </p>
                <p>Lunes - Viernes de 9:00 a.m. - 7:00 p.m.</p>
                <p>Sábados de 8:00 a.m. - 3:00 p.m.</p>
                <p>Domingos de 10:00 a.m. - 3:00 p.m.</p>
              </div>

              <div className="font-bold text-white">
                <p className="flex items-center justify-center gap-2">
                  <FaHeadset className="text-viking" />
                  <span>Centro de asistencia técnica</span>
                </p>
                <p>Lunes - Viernes de 9:00 a.m. - 5:00 p.m.</p>
                <p>Sábados de 9:00 a.m. - 3:00 p.m.</p>
              </div>
            </div>
            <div className="py-10 text-center">
              <p className="text-2xl font-bold">Transparencia</p>

              <div className="py-3 text-white">
                {Transparencia.map((trans) => (
                  <ul key={trans.id}>
                    <li>
                      <a href={trans.url} download>
                        {trans.title}
                      </a>
                    </li>
                  </ul>
                ))}
              </div>
            </div>
            <div className="py-10 text-center">
              <p className="text-2xl font-bold">Ubicación</p>
              <div className="py-4">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4613.237301877837!2d-99.36976899999999!3d20.001352!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjDCsDAwJzA0LjkiTiA5OcKwMjInMTEuMiJX!5e1!3m2!1ses-419!2smx!4v1772165292032!5m2!1ses-419!2smx"
                  title="map"
                  scrolling="no"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="h-full w-full xxl:w-[500px] xxl:h-[250px] md:h-52"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="p-2 text-center text-white bg-gray900">
        <span>
          {new Date().getFullYear()}{" "}
          <span className="font-bold">SinntecPon.</span> Todos los derechos
          reservador
        </span>
      </div>
    </footer>
  );
};

export default Footers;
